 

import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
 
import {appApiResources} from '../../../configuration/app.constants';

@Injectable({
  providedIn: 'root'
})
export class GetOfferingTypeService {

  constructor(private http: HttpClient) {}

  async GetOfferingType() {
    try {
      // const httpOptions = {
      //   headers: new HttpHeaders({
      //     "Content-Type": "application/json",
      //     Authorization: `jwt ${idToken}`
      //   })
      // }; 
      let response = await this.http
        .get(`${appApiResources.getOfferingType}`)
        .toPromise();
      return response;
    } catch (error) { 
      return error;
    }
  }
}